import React from 'react';
///---geolib Lib--///
import * as geolib from 'geolib';
  ///---Services--///
import {request} from "../../services/RequestParams";
import CalculateHash from "../../services/CalculateHash";
import homeServices from '../../services/home-service';
import Tabletop from "tabletop";
  ///---Shared component--///
import Spinner from "../../shared/Spinner"
  //---View--///
import View from '../../views/Search/Search'
import Header from "../../views/Common/Header/Header";
import Footer from "../../views/Common/Footer/Footer";
import axios from 'axios'
export default class Search extends React.Component{
    constructor(props){        
        super(props);
        this.state = {             
            literals : JSON.parse(localStorage.getItem("literals")) || [],                        
            userLanguage : '',
            displayLang : 'en',
            currentPosition : {
                                lat: 45.3473789875323,
                                lng: -75.79342378813136
                            },
            lots: JSON.parse(localStorage.getItem("sheetData")) || [],  
            spinner : false,
            zoom: 11,       
        }
    }      
    
    componentDidUpdate(){
        this.getGeoLocation()
    }  

    componentDidMount() {                  
        var userLang = navigator.language || navigator.userLanguage; 
        userLang = userLang.split('-')[0]              
        this.setState({displayLang : userLang})                        
        this.getGoogleSheetData();         
    }

    getGoogleSheetData(){          
        // Tabletop.init({
        // key: 'https://docs.google.com/spreadsheets/d/19MJNY_yiGz4qVTW5tGfqZJO82JFy9lrMIx6DLw7xQjE/edit?usp=sharing',
        // callback: googleData => {              
        //     // let result = this.mapLanguages(this.state.userLanguage, googleData.Lots.elements);
        //     googleData.Lots.elements.forEach(function (element) {
        //         element.Active = "false";
        //       });
        //     localStorage.setItem('lots', JSON.stringify(googleData.Lots.elements))
        //     localStorage.setItem('literals', JSON.stringify(googleData.Literals.elements))
        //     this.setState({
        //         lots : googleData.Lots.elements,
        //         literals : googleData.Literals.elements,                
        //     },()=>console.log(this.state.sheetData))
        // },
        // simpleSheet: false
        // })
      }      

      selectedLanguage(e){ 
        console.log(e) 
        this.setState({displayLang : e})
        }

    more(id,item){
        console.log(id,item)
        let data = this.state.lots
        data.forEach(function (element) {
            element.Active = "false";
          });
        this.setState({ lots: data });
        data[id].Active = 'true'
        this.setState({ lots: data });
    }

    less(id,item){
        // console.log(id,item)
        let data = this.state.lots
        data[id].Active = 'false'
        this.setState({ lots: data });
    }

  ///---Get current location--///

    getGeoLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                position => {                      
                    this.setState(prevState => ({
                        currentPosition: {
                            ...prevState.currentPosition,
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        }
                    }))                                                            
                }
            )
        }
    }

    selectedZone=(coord)=>{
        this.setState({
            currentPosition : coord,
            zoom : 16
        })
    }

    render(){
        return(
            <div>
                <>                    
                    <View 
                        currentPosition = {this.state.currentPosition}                        
                        zoom = {this.state.zoom}
                        userLanguage = {this.state.userLanguage}
                        handleCityChange = {(e)=>{this.handleCityChange(e)}}
                        handleZoneChange = {(e)=>{this.handleZoneChange(e)}}
                        selectedZone = {(e)=>{this.selectedZone(e)}}
                        centerMoved={(mapProps, map)=>this.centerMoved(mapProps, map)}
                        more={(id, item)=>this.more(id, item)}
                        less={(id, item)=>this.less(id, item)}
                        getGeoLocation = {(e)=>{this.getGeoLocation(e)}}
                        history={this.props.history}
                    />
                    <Spinner 
                        spinner = {this.state.spinner}
                    />                     
                </>
            </div>
        )
    }
}